import { getAccessToken } from '../utils/session';
import { BASE_URL, SAVE_ENTITY_MASTER_API } from "../endpoints/apiEndpoints";

const SaveEntityMasterApi = async (entityData) => {
    const apiUrl = `${BASE_URL}/${SAVE_ENTITY_MASTER_API}`;
    const token = getAccessToken();
    try {
        const payload = {
            entityName: entityData.entityName.trim(),
            entityPan: entityData.entityPan
        };
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload)
        };

        // Make the API request
        const response = await fetch(apiUrl, requestOptions);

        // Handle HTTP errors
        if (!response.ok) {
            // Try to get error details from response if available
            let errorMessage;
            try {
                const errorData = await response.json();
                errorMessage = errorData.error || `Request failed with status: ${response.status}`;
            } catch {
                errorMessage = `Request failed with status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }

        // Parse and return the successful response
        const data = await response.json();
        return {
            success: true,
            data
        };

    } catch (error) {
        // Handle network errors or other exceptions
        console.error('Error fetching entity master data:');
        return {
            success: false,
            error: error.message || 'Failed to fetch entity master data'
        };
    }
};

export default SaveEntityMasterApi;